import { Mail, MapPin, Phone } from 'lucide-react'
import { site } from '../content/site'
import { ArrowIcon } from './ArrowIcon'
import { Logo } from './Logo'

export function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="shell footer-grid">
        <div className="footer-brand">
          <Logo inverse />
          <p>{site.proposalLine}</p>
        </div>
        <div className="footer-contact">
          <span className="section-kicker">Applicant</span>
          <strong>{site.applicant}</strong>
          <a href={`tel:${site.phone.replace(/\s/g, '')}`}><Phone aria-hidden="true" />{site.phone}</a>
          <a href={`mailto:${site.email}`}><Mail aria-hidden="true" />{site.email}</a>
          <span><MapPin aria-hidden="true" />{site.location}</span>
        </div>
        <div className="footer-cta">
          <span className="section-kicker">Application contact</span>
          <p>For leasing inquiries or additional requirements related to the BISEN proposal, please contact the applicant directly.</p>
          <a className="button button--light" href={`mailto:${site.email}`}>
            Contact applicant <ArrowIcon />
          </a>
        </div>
      </div>
      <div className="shell footer-bottom">
        <span>© 2026 BISEN · KCC Mall proposal</span>
        <a href="#top">Back to top ↑</a>
      </div>
    </footer>
  )
}
